/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Exclude_FsInputs */

const en_subtitle_export_exclude_fs = /** @type {(inputs: Subtitle_Export_Exclude_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exclude FS`)
};

const fr_subtitle_export_exclude_fs = /** @type {(inputs: Subtitle_Export_Exclude_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exclure FS`)
};

const de_subtitle_export_exclude_fs = /** @type {(inputs: Subtitle_Export_Exclude_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FS ausschließen`)
};

const it_subtitle_export_exclude_fs = /** @type {(inputs: Subtitle_Export_Exclude_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escludi FS`)
};

const ru_subtitle_export_exclude_fs = /** @type {(inputs: Subtitle_Export_Exclude_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Исключить FS`)
};

const es_subtitle_export_exclude_fs = /** @type {(inputs: Subtitle_Export_Exclude_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir FS`)
};

const zh_cn2_subtitle_export_exclude_fs = /** @type {(inputs: Subtitle_Export_Exclude_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排除 FS`)
};

const ja_subtitle_export_exclude_fs = /** @type {(inputs: Subtitle_Export_Exclude_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FSを除外`)
};

const hi_subtitle_export_exclude_fs = /** @type {(inputs: Subtitle_Export_Exclude_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एफएस को बाहर रखें`)
};

const pt_pt2_subtitle_export_exclude_fs = /** @type {(inputs: Subtitle_Export_Exclude_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir FS`)
};

/**
* | output |
* | --- |
* | "Exclude FS" |
*
* @param {Subtitle_Export_Exclude_FsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_exclude_fs = /** @type {((inputs?: Subtitle_Export_Exclude_FsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Exclude_FsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_exclude_fs(inputs)
	if (locale === "de") return de_subtitle_export_exclude_fs(inputs)
	if (locale === "it") return it_subtitle_export_exclude_fs(inputs)
	if (locale === "ru") return ru_subtitle_export_exclude_fs(inputs)
	if (locale === "es") return es_subtitle_export_exclude_fs(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_exclude_fs(inputs)
	if (locale === "ja") return ja_subtitle_export_exclude_fs(inputs)
	if (locale === "hi") return hi_subtitle_export_exclude_fs(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_exclude_fs(inputs)
	return en_subtitle_export_exclude_fs(inputs)
});